import {
  KEY__PROVIDER__GREENHOUSE,
  KEY__PROVIDER__GREENHOUSE_HARVEST
} from '../../../../dictionaries/Providers.dic';
import Core from '../../../Core';
import Http from '../../../Http';

export async function fetchGreenhouseReferrers({
  employerId = '62c62df4ca79ef3fdc0892ad'
}) {
  try{
    return await Http.post(
      Core.getApi('Engagements/postAts'),
      {
        PROVIDER: KEY__PROVIDER__GREENHOUSE,
        SUB_GROUP: KEY__PROVIDER__GREENHOUSE_HARVEST,
        ACTION: 'get',
        PATH: '/referrers',
        PARAMS: {
          per_page: 500,
        },
        EMPLOYER_ID: employerId
      }
    );
  }
  catch (error) {
    Core.showError('Failed to fetch Greenhouse Referrers. Try re-connect your account.', error);
    return [];
  }
}
